module.exports = __webpack_public_path__ + "img/pc_p3_x1.6479d6fe.svg";